import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getServices, removeService } from 'slice/serviceSlice';
import AdminTable from 'common/AdminTable';
import { Link, useNavigate } from 'react-router-dom';

const List = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const serviceData = useSelector((state) => state.service);

    useEffect(() => {
        dispatch(getServices());
    }, [dispatch]);

    const tableHeaders = [
        { Header: 'ID', accessor: 'id' },
        { Header: 'Service Name', accessor: 'name' },
        { 
            Header: 'Image', 
            accessor: 'image',
            Cell: ({ row }) => {
                const backend = process.env.REACT_APP_BACKEND || "http://localhost:8001/";
                const base = backend.endsWith('/') ? backend : backend + '/';
                const imgUrl = `${base}uploads/${row.original.image}`;
                return <img src={imgUrl} alt={row.original.name} style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
            }
        },
        { 
            Header: 'PDF File', 
            accessor: 'pdfFile',
            Cell: ({ row }) => {
                if (!row.original.pdfFile) return 'N/A';
                const backend = process.env.REACT_APP_BACKEND || "http://localhost:8001/";
                const base = backend.endsWith('/') ? backend : backend + '/';
                const pdfUrl = `${base}uploads/${row.original.pdfFile}`;
                return <a href={pdfUrl} target="_blank" rel="noopener noreferrer">View PDF</a>;
            }
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <>
                    <button 
                        className="btn updatebtn mx-1" 
                        onClick={() => navigate(`/khajuraho/services/update/${row.original.id}`)}
                    >
                        Edit
                    </button>
                    <button 
                        className="btn removebtn mx-1" 
                        onClick={() => {
                            if(window.confirm('Are you sure?')) {
                                dispatch(removeService(row.original.id));
                            }
                        }}
                    >
                        Remove
                    </button>
                </>
            ),
        },
    ];

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4 d-flex justify-content-between align-items-center">
                <h4 className="text-white font-weight-bold">Services List</h4>
                <Link to="/khajuraho/services/add" className="btn btn-light btn-sm font-weight-bold">Add New Service</Link>
            </div>
            <div className="mt-4">
                {serviceData?.loading ? (
                    <div className="text-center text-white">Loading...</div>
                ) : (
                    <AdminTable tableHeaders={tableHeaders} tableData={serviceData.data || []} />
                )}
            </div>
        </div>
    );
};

export default List;
